import { type SystemPath, getSystemPathWithProtocolPrefix } from './cep';
import { sanitizeFileName } from '@mimir/common/platformAbstraction/filesystemLimitations';
import { makeDirWith } from '@mimir/client-common/upload/premiere';
import type { AdobePanelContext, ElectronContext } from '@mimir/common/context/applicationContext';
import type { Logger } from '@mimir/common/types/logger';

export const getSystemPath = (adobeContext: AdobePanelContext | ElectronContext, pathType: SystemPath) => {
  let systemPath = getSystemPathWithProtocolPrefix(pathType);
  if (adobeContext.isWindows) {
    systemPath = systemPath.replace('file:///', '').replace(/\//g, '\\');
  } else if (adobeContext.isMac) {
    systemPath = systemPath.replace('file://', '');
  }
  return systemPath;
};

export function makeDir(
  services: {
    logger: Logger;
    applicationContext: AdobePanelContext | ElectronContext;
  },
  dirPath: string,
) {
  return makeDirWith(services, dirPath);
}

export const getSanitizedFileNameForScript = (applicationContext: AdobePanelContext | ElectronContext, name: string) => {
  // Remove platform specific invalid characters and escape double quotes
  const sanitizedName = sanitizeFileName(name, applicationContext.isWindows).replace(/"/g, '\\"');

  return sanitizedName;
};

